import DeployToLand from './DeployToLand.container'

export default DeployToLand
